export default "__VITE_ASSET__ea602f02__$_?nuxt_component=async__"